import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'header-roles',
    templateUrl: 'header-roles.component.html',
    styleUrls: ['header-roles.component.scss'],
    standalone: false
})
export class HeaderRolesComponent {
	@Input() selectedZoneDisplayName: string = '';
	@Input() zones: { code: string; displayName: string; }[] = [];

	@Output() zoneClick = new EventEmitter<string>();

	public trackByCode(_index: number, zone: { code: string }): string {
		return zone.code;
	}

	public onZoneClick(zoneCode: string): void {
		this.zoneClick.emit(zoneCode);
	}
}
